module.exports = __webpack_public_path__ + "img/learner-quiz-Moose-Q1.256ac795.png";